module.exports = __webpack_public_path__ + "static/img/today_best_team.8607f4f3.png";